import { defineStore } from 'pinia';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useMessagesStore } from './useMessagesStore';

export const useChatStartersStore = defineStore('chatStarters', () => {
  const { lastMessage } = storeToRefs(useMessagesStore());

  const starters = computed(() => {
    if (lastMessage.value) {
      if (lastMessage.value.role === 'assistant') {
        const content = lastMessage.value.content;
        return [{ displayText: content, message: null }];
      }
      return [];
    } else {
      return [
        { displayText: 'Looking for an RV', message: 'Looking for an RV' },
      ];
    }
  });

  return {
    starters,
  }
});